import React from 'react';
import { Section } from '../ui/Section';
import { Shield, Eye, Zap, Lock, Target, Brain } from 'lucide-react';
export function BenefitsGrid() {
  const benefits = [{
    icon: Eye,
    title: 'Detectá Mentiras',
    desc: 'Leé microexpresiones invisibles para el ojo no entrenado.'
  }, {
    icon: Shield,
    title: 'Blindaje Mental',
    desc: 'Hacete inmune a la manipulación emocional y el gaslighting.'
  }, {
    icon: Zap,
    title: 'Respeto Instantáneo',
    desc: 'Entrá a cualquier lugar y proyectá autoridad sin decir una palabra.'
  }, {
    icon: Lock,
    title: 'Control de Marcos',
    desc: 'Dominá la dirección de cualquier conversación difícil.'
  }, {
    icon: Target,
    title: 'Negociación Real',
    desc: 'Conseguí lo que querés sin ceder terreno ni parecer agresivo.'
  }, {
    icon: Brain,
    title: 'Psicología Oscura',
    desc: 'Entendé las tácticas que usan contra vos para neutralizarlas.'
  }];
  return <Section className="bg-zinc-900/50 border-y border-zinc-800" data-id="element-15">
      <div className="text-center mb-16" data-id="element-16">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-17">
          Qué va a cambiar en vos
        </h2>
        <div className="w-20 h-1 bg-yellow-500 mx-auto rounded-full" data-id="element-18" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-19">
        {benefits.map((b, i) => <div key={i} className="bg-black border border-zinc-800 p-6 rounded-xl hover:border-yellow-500/50 transition-colors group" data-id="element-20">
            <div className="w-12 h-12 bg-zinc-900 rounded-lg flex items-center justify-center mb-4 group-hover:bg-yellow-500 transition-colors" data-id="element-21">
              <b.icon className="w-6 h-6 text-yellow-500 group-hover:text-black transition-colors" data-id="element-22" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-23">{b.title}</h3>
            <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-24">{b.desc}</p>
          </div>)}
      </div>

      <div className="mt-16 text-center" data-id="element-25">
        <p className="text-zinc-500 uppercase tracking-widest text-sm font-bold" data-id="element-26">
          Esto no es motivación. Es entrenamiento táctico.
        </p>
      </div>
    </Section>;
}